module.exports = __webpack_public_path__ + "img/email.06c7a90a.svg";